export default "__VITE_ASSET__b31e718f__"